"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditContractForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const contract_1 = require("../../../model/contract");
const auth_1 = require("../../../utils/auth");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const right_panel_1 = require("../../../widgets/right_panel");
const contract_show_1 = require("./contract_show");
const contract_table_1 = require("./contract_table");
const moment = require("moment");
function renderForm(form) {
    var _a;
    return form.fieldset("", {}, form.errorBlock(), form.checkbox("Forfait actif ?", "active"), (0, helpers_1.ifTrue)(!form.obj.active && auth_1.Auth.isAdminOnly(), (0, mithril_1.default)("div", form.checkbox("Mettre les heures à zero (/!\\ ne seront pas calculé dans le consommé)", "zeroing_remaining_hours"))), form.field("Quota d'annulation gratuit (minutes)", "remaining_cancelable_free_minutes", "number"), form.field("Date d'expiration du forfait", "expires_at", "date", {
        renderValue: (date) => {
            return moment(date).format("YYYY-MM-DD");
        },
        transformValue: (date) => {
            return moment(date, "YYYY-MM-DD").format();
        }
    }), (0, helpers_1.ifTrue)(form.obj.invoice, form.field("Numéro de facture", "reference", "text", {
        value: (_a = form.obj.invoice) === null || _a === void 0 ? void 0 : _a.reference,
        oninput: (evt) => {
            evt.preventDefault();
            form.obj.invoice.reference = evt.target.value;
        }
    })));
}
exports.EditContractForm = {
    active: false,
    contract: {},
    title(form) {
        return `Editer Forfait ${form.obj.id}`;
    },
    view(_vnode) {
        if (this.active) {
            let form = (0, form_for_1.formFor)(this.contract, contract_1.ContractProvider, (form) => {
                return (0, modal_1.modalCard)({
                    title: this.title(form),
                    content: renderForm(form),
                    foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit(form.isNew() ? "Créer" : "Mettre à jour", {
                        onsubmit: (_obj) => {
                            notification_center_1.Notification.success(`Le forfait #${this.contract.id} a bien été mis à jour.`, right_panel_1.RightPanel.linkTo("Afficher", "contracts", this.contract.id, "show"));
                            contract_table_1.ContractTable.fetch();
                            contract_show_1.ContractShow.fetch(this.contract.id);
                            exports.EditContractForm.active = false;
                        }
                    })),
                    isActive: exports.EditContractForm.active,
                    onClose: () => { exports.EditContractForm.active = false; }
                });
            });
            return form;
        }
        return undefined;
    },
    show(contract) {
        contract_1.ContractProvider.clearError();
        this.contract = contract;
        this.active = true;
    },
};
